import { configureStore } from '@reduxjs/toolkit';
import appMode from './appMode/appMode.slice';
import cart from './cart/cart.slice';
import commands from './command/command.slice';
import config from './config/config.slice';
import fraud from './fraud/fraud.slice';
import message from './message/message.slice';
import review from './review/review.slice';
import upiMopMode from './upiMop/upiMop.slice';
import listeners from '../redux/listeners';
import { initStoreListeners } from '../redux/initStoreListeners';
import { combineReducers } from '@reduxjs/toolkit';
var reducer = combineReducers({
  appMode: appMode,
  cart: cart,
  commands: commands,
  config: config,
  fraud: fraud,
  message: message,
  review: review,
  upiMopMode: upiMopMode
});
export var createStore = function createStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var listenerMiddleware = initStoreListeners(listeners);
  var store = configureStore({
    reducer: reducer,
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['AdobeAnalytic/LOG_ADOBE_ORDER_CONFIRMATION_PIXEL']
        }
      }).prepend(listenerMiddleware.middleware);
    },
    preloadedState: initialState
  });
  return store;
};
var store = createStore({});
export default createStore;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/store.js
// module id = 4682
// module chunks = 11